import { createFileRoute } from '@tanstack/react-router';

const APP_STORE_URL = 'https://apps.apple.com/app/id6767838042';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.infiltre.app';

function pickStore(ua: string): string | null {
  if (/iPhone|iPad|iPod/i.test(ua)) return APP_STORE_URL;
  if (/Android/i.test(ua)) return PLAY_STORE_URL;
  return null;
}

export const Route = createFileRoute('/get')({
  beforeLoad: () => {
    if (typeof window === 'undefined') return;
    const dest = pickStore(navigator.userAgent);
    if (dest) {
      window.location.replace(dest);
    } else {
      window.location.replace('/');
    }
  },
  component: () => null,
});
